import TextUtils from './text-utils'

const scrubbedValues = {
  scrubbed: 'SCRUBBED_ADDRESS',
  user: 'USER_ADDRESS',
  invalid: 'INVALID_PP_ADDRESS',
  unscrubbed: 'NOT_SCRUBBED',
}

class USPSUtils {

  static get SCRUBBED_VALUES() {
    return scrubbedValues
  }

  static mapUSPSAddressPayload(address, countriesModel) {
    const mappedPayload = {
      addressType: address.addressType,
      addressLine1: address.line1,
      addressLine2: address.line2 || '',
      city: address.city,
      countryName: countriesModel.countryCodeToName(address.countryCode).name,
      countryCode: address.countryCode,
      firstName: address.firstName,
      isCanadian: false,
      isDomestic: true,
      isInternational: false,
      isMilitary: false,
      lastName: address.lastName,
      scrubStatus: scrubbedValues.unscrubbed,
      stateCode: address.stateCode,
      zipCode: address.postalCode,
      personTitle: address.prefix,
      personSuffix: address.suffix,
      email1: address.email,
      phone1: address.phoneNumber,
    }

    return JSON.stringify(mappedPayload)
  }

  // Unmaps the payload from the USPS
  // scrubbing service so it conforms
  // to the expected schema
  static unmapUSPSAddressPayload(response) {
    const unmappedPayload = {
      address: {
        firstName: response.firstName,
        lastName: response.lastName,
        line1: TextUtils.toTitleCase(response.addressLine1),
        line2: TextUtils.toTitleCase(response.addressLine2),
        city: TextUtils.toTitleCase(response.city),
        stateCode: response.stateCode,
        countryCode: response.countryCode,
        postalCode: response.zipCode,
        scrubStatus: response.scrubStatus,
        prefix: response.personTitle,
        suffix: response.personSuffix,
        email: response.email1,
        phoneNumber: response.phone1,
        addressType: response.addressType,
      },
    }
    return unmappedPayload
  }
}

export default USPSUtils
